import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { UserAuthority } from './domain/model/user-authority';
import { AuthenticationService } from '@app/shared/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  constructor(private readonly authenticator: AuthenticationService,
    private readonly router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const authorities: UserAuthority[] = next.data['authorities'];
    let authorized = false;

    if (authorities) {
      const user = this.authenticator.getCurrentUser();

      if (user) {
        authorized = user.hasAnyOfAuthorities(authorities);
      }
    } else {
      authorized = this.authenticator.isLoggedIn();
    }

    if (!authorized) {
      const route: any[] = next.data['redirectTo'];

      this.router.navigate(route ? route : ['/login'], { queryParams: { returnUrl: state.url } });
    }

    return authorized;
  }

}
